function ConsultantTeam() {
  return <div>Consultant Team</div>;
}

export default ConsultantTeam;
